export default __webpack_public_path__ + "static/media/facebook-icon.12fd3a81.svg";